import { takeEvery } from 'redux-saga/effects';
import { notification } from 'antd';
import i18n from '../i18n';

function showRollbackError(action: any) {
  try {
    let translatedErrorMessage: string | undefined =
      action?.payload?.response?.TranslatedMessage;

    if (
      translatedErrorMessage &&
      translatedErrorMessage.trim().toLowerCase().replace(' ', '') ===
        'unhandledexception'
    ) {
      translatedErrorMessage = undefined;
    }

    const {
      snackbarErrorMessage: { label, timeout, title, placement, parameters },
    } = action;

    notification.open({
      message: title ? i18n.t(title) : i18n.t('common:error'),
      description:
        translatedErrorMessage ?? (label && i18n.t(label, parameters)),
      duration: timeout,
      placement,
    });
  } catch (error) {}
}

export default function* watchRollbacks() {
  yield takeEvery<any>(
    (action) =>
      !(action.cancel || action.aborted) &&
      /_ROLLBACK$/.test(action.type) &&
      action.snackbarErrorMessage,
    showRollbackError
  );
}
